import {TranslateService} from '@ngx-translate/core';
import {IProjekt} from '../../../shared/model/projekt.model';
import {VocabularyNames} from '../../userlist/consultant-search-text';

function monthYear(value: Date | string | undefined | null): string {
  if (!value) return '';
  const date = new Date(value);
  if (isNaN(date.getTime())) return '';
  return `${String(date.getMonth() + 1).padStart(2, '0')}/${date.getFullYear()}`;
}

function text(value: unknown): string {
  return value === null || value === undefined ? '' : String(value);
}

/**
 * NP20-824: Suchtexte eines Projekts, das gerade nicht gerendert ist. Spiegelt den
 * Lesemodus von ProjectComponent (Beschriftungen und Werte je Textknoten), damit die
 * Trefferzahl zu dem passt, was nach dem Aufklappen im DOM steht — bei Änderungen am
 * Template hier nachziehen.
 */
export function projectSearchTexts(projekt: IProjekt, translate: TranslateService, vocabulary: VocabularyNames): string[] {
  const t = (key: string): string => translate.instant(key);
  const methods = projekt.methodik ?? [];
  const tasks = projekt.tasks ?? [];

  return [
    t('project.projectQuestion'),
    t('project.textPartOne'),
    monthYear(projekt.beginn),
    t('project.textPartTwo'),
    projekt.ende ? monthYear(projekt.ende) : t('project.textPartThree'),
    `${t('project.textPartFour')}"${text(projekt.projektname)}"`,
    `${t('project.textPartFive')} ${text(projekt.kunde)}`,
    `${t('project.textPartSix')} ${text(projekt.stelle)}`,
    t('project.textPartSeven'),
    t('project.projectInformation'),
    t('project.projectIndustries'),
    ...(projekt.branchNames ?? []).map(industry => vocabulary.industryName(industry)),
    t('project.projectSize'),
    text(projekt.teamSize),
    t('project.projectTester'),
    text(projekt.numberTester),
    t('project.projectTotalSize'),
    text(projekt.projectSize),
    t('project.projectDeploymentLocation'),
    text(projekt.workLocation),
    t('project.projectDescription'),
    text(projekt.beschreibung),
    t('project.methodology'),
    ...methods.map(method => vocabulary.methodName(method)),
    ...(methods.length > 1 ? ['und'] : []),
    ...(tasks.length ? [t('project.tasks')] : []),
    ...tasks.flatMap((task, idx) => [
      `${t('project.task')} ${idx + 1} - ${text(task?.caption)}`,
      t('project.title'),
      text(task?.caption),
      t('project.description'),
      text(task?.details),
      t('project.skills'),
      ...new Set((task?.skills ?? []).map(skill => vocabulary.skillCategory(skill))),
      ...(task?.skills ?? []).map(skill => vocabulary.skillName(skill)),
    ]),
  ].filter(value => value.trim().length > 0);
}
